import React, { useState } from "react";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../components/collapseAbleTable/CollapseableTable";
import { Table } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useFetchItems from "../../hooks/useFetchItems";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import useGetAttributes from "../../hooks/useGetAttributes";
import moment from "moment";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";
const moduleNames = [
  "Insurance Products",
];

export default function InsuranceCoverage() {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const AddInsurance = () => {
    history.push("/insurance_new");
  };

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useFetchItems(moduleNames, setLoading);

  const tableDataObj = {
   "Insurance Policies":tableData.insurancePoliciesData
  };

  console.log("tableData", tableData);

  console.log("Table Data Obj", tableDataObj)
  const columns = [
   {
         title: "Policy Name",
         dataIndex: "Nickname",
         key: "Nickname",
         render: (record) => (record ? record : "N/A"),
       },
       {
         title: "Policy Start Date",
         dataIndex: "Policy Start Date",
         key: "Policy Start Date",
         render: (record) =>
           record ? moment(record).format("DD-MM-YYYY") : "N/A",
       },
       {
         title: "Policy End Date",
         dataIndex: "Policy End Date",
         key: "Policy End Date",
         render: (record) =>
           record ? moment(record).format("DD-MM-YYYY") : "N/A",
       },
       {
         title: "Insurance Company",
         dataIndex: "Carrier",
         key: "Carrier",
         render: (record) => (record ? record : "N/A"),
       },
       {
         title: "Policy Number",
         dataIndex: "Policy Number",
         key: "Policy Number",
         render: (record) => (record ? record : "N/A"),
       },
       {
         title: "Year Premium",
         dataIndex: "year_premium",
         key: "year_premium",
         render: (record) => (record ? record : "N/A"),
       },
  ];

    const { attributes, disasterAttribute } = useGetAttributes(
      moduleNames,
      setLoading
    );

    console.log("Insurance Coverage Attributes",attributes);
    console.log("Insurance Coverage DisasterAttributes",disasterAttribute);
  
  return (
    <>
      <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
        <h2 className="parent-title">Insurance Coverage</h2>
        <ToolTipCreator name={"Disaster_Insurance_Coverage"}/>
      </div>
        {/* <div className="parent-icon-container">
          <img src={helpIcon} alt="help icon" width="18.67px" height="18.67px" />
        </div> */}
      </div>
      {
        <CollapseableTable title={"Insurance Policies"} onClick={AddInsurance}>
          <Table columns={columns} dataSource={tableData.insuranceProductsData} />
          <NewLoader isLoading={loading} />
        </CollapseableTable>
      }
    </>
  );
}
